import { observer } from 'mobx-react'
import ContentState from '../../../../stores/ContentState'
import './index.scss'
import { changeCoopState } from '../../../../stores/GlobalState'
const ContactContent = observer(() => {
  if (!ContentState.contact) return <></>
  const content: any = ContentState.contact
  return (
    <section className="contact-page">
      <div className="contact-page__row first">
        <div className="contact-page__col row-but">
          <div className="button black"
          onClick={changeCoopState}>{content.buttonTitle}</div>
          <div
            className="contact-page__text-slim"
            dangerouslySetInnerHTML={{ __html: content.mainText }}
          ></div>
        </div>
      </div>
      <div className="contact-page__row row-reverse">
        <div className="contact-page__block black">
          <div className="contact-page__block-title">
            {content.block1.title}
          </div>
          <div className="contact-page__block-row">
            <div className="contact-page__block-col">
              <div className="contact-page__block-subtitle p0">
                {content.block1.emailTitle}
              </div>
            </div>
            <div className="contact-page__block-col">
              <div
                className="contact-page__block-text"
                onClick={() =>
                  (window.location.href = `mailto:${content.block1.email}`)
                }
              >
                {content.block1.email}
              </div>
            </div>
          </div>
          <div className="contact-page__block-row">
            <div className="contact-page__block-col">
              <div className="contact-page__block-subtitle">
                {' '}
                {content.block1.phoneTitle}
              </div>
            </div>
            <div className="contact-page__block-col">
              {content.block1.phones.map((p: any, i: number) => (
                <div
                  className="contact-page__block-text"
                  key={i}
                  onClick={() => (window.location.href = `tel:${p}`)}
                >
                  {p}
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="contact-page__block white">
          <div className="contact-page__block-title">
            {content.block2.title}
          </div>
          <div className="contact-page__block-row">
            <div className="contact-page__block-col">
              <div className="contact-page__block-subtitle">
                {content.block2.ukrTitle}
              </div>
            </div>
            <div className="contact-page__block-col">
              <div
                className="contact-page__block-text"
                onClick={() =>
                  (window.location.href = `tel:${content.block2.ukrPhone}`)
                }
              >
                {content.block2.ukrPhone}
              </div>
            </div>
          </div>
          <div className="contact-page__block-row">
            <div className="contact-page__block-col">
              <div className="contact-page__block-subtitle">
                {' '}
                {content.block2.internationalTitle}
              </div>
            </div>
            <div className="contact-page__block-col">
               {content.block2.internationalPhone?.map((p: any, i: number) => (
                <div
                  className="contact-page__block-text"
                  key={i}
                  onClick={() => (window.location.href = `tel:${p}`)}
                >
                  {p}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
})

export default ContactContent
